import React, { useState } from 'react'
import MDButton from 'components/MDButton'
import MDModal from 'components/MDModal'
import MDBox from 'components/MDBox'
import MDTypography from 'components/MDTypography'
import MDInput from 'components/MDInput'
import { useAppServices } from 'hook/aiservices'

const EditAgentFunctionModal = ({ data, handleRefresh, index, assistantId, appId }) => {
  console.log(data, 'datadata')
  const AppService = useAppServices()
  const [openEditProduct, setOpenEditProduct] = useState(false)
  const [processing, setProcessing] = useState(false)

  const handleModal = () => {
    setOpenEditProduct(true)
  }

  const closeEditProduct = () => {
    setOpenEditProduct(false)
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    setProcessing(true)

    // Check if document exists
    // const { response: existingDoc } = await AppService.app_function.getAll({
    //   query: `assistantId=${assistantId}&appId=${appId}`,
    // })
    const newEntry = {
      name: e.target.name.value,
      key: e.target.key.value,
      functionData: e.target.functionData.value,
      // isActive: existingDoc.data[0].isActive,
    }

    let res
    // if (existingDoc?.data?.length) {
    const updatedPayload = {
      assistantId: assistantId,
      appId: appId,
      functionIndex: index,
      functionData: newEntry, // use updatedPartnerData instead of existingDoc.data[0].applications
    }

    res = await AppService.app_function.update({
      payload: updatedPayload,
    })
    // }

    setProcessing(false)
    setOpenEditProduct(false)
    handleRefresh()
  }

  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    maxHeight: '80vh',
    overflow: 'auto',
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
  }

  return (
    <>
      <MDButton color="info" variant="contained" onClick={handleModal}>
        Edit
      </MDButton>
      <MDModal open={openEditProduct} onClose={closeEditProduct}>
        <MDBox>
          <MDBox
            component="form"
            onSubmit={handleSubmit}
            role="form"
            sx={style}
            encType="multipart/form-data"
          >
            <MDTypography variant="h5" mb={2}>
              Edit Function
            </MDTypography>
            <MDTypography variant="h5" mb={2}>
              Create Function
            </MDTypography>

            <MDBox mb={2}>
              <MDTypography variant="button">Name</MDTypography>
              <MDInput label="Name" name="name" fullWidth required defaultValue={data.name} />
            </MDBox>

            <MDBox mb={2}>
              <MDTypography variant="button">Key</MDTypography>
              <MDInput label="Key" name="key" fullWidth required defaultValue={data.key} />
            </MDBox>

            <MDBox mb={2}>
              <MDTypography variant="button">Function JSON</MDTypography>
              <MDInput
                label="Function JSON"
                name="functionData"
                fullWidth
                required
                multiline
                rows={4} // You can change this to however many rows you want
                defaultValue={data.functionData}
              />
            </MDBox>

            <MDBox display="flex" justifyContent="flex-end">
              <MDButton
                variant="gradient"
                color="primary"
                type="button"
                sx={{ mt: 2, mb: 1 }}
                onClick={closeEditProduct}
              >
                Close
              </MDButton>
              <MDButton
                variant="gradient"
                color="info"
                type="submit"
                sx={{ mt: 2, mb: 1, ml: 1 }}
                loading={processing}
                disabled={processing}
              >
                Save
              </MDButton>
            </MDBox>
          </MDBox>
        </MDBox>
      </MDModal>
    </>
  )
}

export default EditAgentFunctionModal
